import React, { lazy } from 'react';
import { MediaPlaceholder } from './MediaPlaceholder';
import { CtaButton } from './CtaButton';
import { ShieldCheck, Lock, CreditCard, Users, Zap } from 'lucide-react';
const badges = [{
  icon: ShieldCheck,
  label: 'Garantía 7 días'
}, {
  icon: Lock,
  label: 'Pago seguro'
}, {
  icon: CreditCard,
  label: 'Mercado Pago'
}, {
  icon: Users,
  label: '+3.597 Alumnas'
}, {
  icon: Zap,
  label: 'Acceso en 5 minutos'
}];
export function HeroSection() {
  return <section className="px-4 pt-6 pb-0 flex flex-col items-center text-center relative z-10 max-w-7xl mx-auto w-full" data-id="element-156">
      {/* Premium Container wrapping EVERYTHING */}
      <div className="w-full max-w-5xl relative rounded-[3rem] p-[2px] bg-gradient-to-b from-[#ff2a7a]/80 via-[#0a0a12] to-[#0a0a12] shadow-[0_0_60px_-15px_rgba(255,42,122,0.5)] mb-0 mt-4" data-id="element-157">
        <div className="bg-[#0a0a12] backdrop-blur-xl rounded-[2.9rem] px-4 py-10 md:px-10 md:py-12 relative overflow-hidden flex flex-col items-center" data-id="element-158">
          {/* Ambient neon pink glow inside */}
          <div className="absolute top-1/4 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#ff2a7a]/15 blur-[120px] rounded-full pointer-events-none" data-id="element-159" />

          {/* Hero Title Area */}
          <div className="w-full mb-8 flex flex-col items-center relative z-10" data-id="element-160">
            {/* Discount Badge */}
            <div className="text-brand-navy font-black text-[10px] md:text-sm px-8 py-2.5 rounded-full mb-8 shadow-[0_0_20px_rgba(255,42,122,0.6)] border border-white/60 uppercase tracking-widest bg-gradient-to-r from-brand-cream via-white to-brand-cream pt-[10px] pb-[10px]" data-id="element-161">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#ff2a7a] to-brand-pinkDark" data-id="element-162">
                50% OFF - CUPOS LIMITADOS
              </span>
            </div>

            <div className="relative w-full flex justify-center" data-id="element-163">
              <h1 className="text-white font-black tracking-tight uppercase text-[30px] leading-[1] md:text-[54px] md:leading-[1] relative z-10 drop-shadow-2xl mt-[0px] mb-[0px]" style={{
              fontFamily: "'Inter', sans-serif",
              fontWeight: 900
            }} data-id="element-164">
                APRENDÉ A CREAR{' '}
                <span className="neon-pink normal-case italic font-bold" style={{
                fontFamily: "'Dancing Script', cursive"
              }} data-id="element-165">
                  Videos UGC
                </span>{' '}
                Y TRABAJA CON LAS MARCAS{' '}
                <span className="neon-pink normal-case italic font-bold" style={{
                fontFamily: "'Dancing Script', cursive"
              }} data-id="element-166">
                  desde casa
                </span>{' '}
                💸
              </h1>
            </div>

            <p className="text-lg md:text-2xl uppercase tracking-tight font-[700] font-[Montserrat,_sans-serif] text-white/90 mt-4 drop-shadow-md" data-id="element-167">
              ✨ Sin experiencia ni seguidores. ✨ Desde cero, Con consultorías
              y acompañamiento 💻
            </p>
          </div>

          {/* Initial Video */}
          <div className="w-full relative max-w-4xl z-10" data-id="element-168">
            <div className="absolute -inset-2 bg-gradient-to-tr from-[#ff2a7a] to-brand-lavender rounded-3xl blur-xl opacity-50 animate-pulse" data-id="element-169"></div>
            <div className="relative w-full aspect-video rounded-3xl overflow-hidden shadow-[0_20px_50px_-12px_rgba(0,0,0,0.5)] bg-black z-10 border border-[#ff2a7a]/50" data-id="element-170">
              <iframe src="https://player.vimeo.com/video/1200659338?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" loading="lazy" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" className="absolute top-0 left-0 w-full h-full" title="formula_creadora_de_contenido_ugc_v3 (1080p)" data-id="element-171"></iframe>
            </div>
          </div>

          {/* Copy */}
          <p className="text-white/90 font-medium md:text-3xl mb-8 px-4 max-w-4xl text-[17px] leading-relaxed relative z-10 mt-10" data-id="element-172">
            Con mi método paso a paso, dejá de improvisar y empezá a cobrar
            +$150 usd por cada video UGC como una Creadora PRO💸✨
          </p>

          {/* Students count */}
          <div className="flex items-center gap-2 mb-8 bg-white/10 px-6 py-2 rounded-full border border-white/20 shadow-sm relative z-10" data-id="element-173">
            <span className="text-yellow-400 text-xl tracking-widest" data-id="element-174">
              ★★★★★
            </span>
            <p className="text-white font-bold md:text-xl" data-id="element-175">
              +3.597 Alumnas UGC
            </p>
          </div>

          {/* CTA */}
          <div className="md:scale-110 md:my-4 w-full max-w-md relative z-10" data-id="element-176">
            <CtaButton variant="gold" data-id="element-177">QUIERO CREAR VIDEOS UGC</CtaButton>
          </div>

          {/* Trust badges */}
          <div className="flex flex-wrap justify-center mt-8 px-6 py-4 bg-white/5 backdrop-blur-md rounded-2xl border border-white/10 shadow-sm max-w-4xl w-full relative z-10" data-id="element-178">
            <span className="text-[11px] md:text-sm font-semibold text-white/70 text-center leading-relaxed tracking-wide" data-id="element-179">
              🛡️ Garantía 7 días &nbsp;•&nbsp; 🔒 Pago seguro &nbsp;•&nbsp; 💳
              Mercado Pago &nbsp;•&nbsp; ⭐ +3.597 Alumnas &nbsp;•&nbsp; ⚡
              Acceso en 5 minutos
            </span>
          </div>
        </div>
      </div>
    </section>;
}